export const iconFontAwesomeMedicalHealthHeartCirclePlus = (
	<i className="fa-solid fa-heart-circle-plus"></i>
);
